<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <div class="h-full w-full relative">

    @if (wellSchematicStore && wellType()) {
      <p-toolbar class="absolute top-0 left-0 right-0 z-10">

        <ng-template #start>
          <div class="space-x-4 flex items-center">
          <p-button class="pl-3" id="exportPng" text size="small" icon="pi pi-download" title="Download .png"
            (click)="onExportPng()"></p-button>

          <p-selectButton
            [options]="schematicOptions()"
            [ngModel]="selectedSchematicOptions()"
            (ngModelChange)="onSchematicOptionsChange($event)"
            optionLabel="label"
            optionValue="value"
            [multiple]="true"
            size="small"
          />
          </div>
        </ng-template>

      </p-toolbar>
    }

    <div class="infoBoxWrapper">
      <app-schematic-info></app-schematic-info>
    </div>

    <div #wellSchematic id="wellSchematic" class="schematic-container" 
      [class.mouseDown]="isPanning()" 
      [style.margin-top.px]="toolbarHeight() / 2"
      [style.height]="'calc(100% - ' + toolbarHeight() / 2 + 'px)'"
      pTooltip="Scroll to Zoom" 
      (dblclick)="resetView()"
      (contextmenu)="onSchematicContextMenu($event)"
      (mousewheel)="onMouseWheel($event)" (mousedown)="onMouseDown($event)" (mouseup)="onMouseUp()"
      (mousemove)="onMouseMove($event)">
      <div class="svg-wrapper" [innerHTML]="svgContent() | sanitizeHtml"></div>
    </div>

  </div>
</app-tool-loader>

<p-contextMenu #schematicCm [model]="schematicContextMenuItems()" appendTo="body"></p-contextMenu>